import React from 'react';
import { toast } from "react-toastify";
import { QuizOutlined as QuizOutlinedIcon } from '@mui/icons-material';
import "./styles.css";
import AddQuizToSectionModal from './AddQuizToSectionModal';
import CompleteQuizModal from './CompleteQuizModal';
import ChecklistIcon from '@mui/icons-material/Checklist';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Check as CheckIcon } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export const Quiz = (props) => {
  const t = (english, spanish, chinese) => {
    if (props.language === "chinese") return chinese;
    if (props.language === "spanish") return spanish;
    return english;
  };

  const questionCountLabel = (count) => {
    if (props.language === "chinese") {
      return `${count} ${count === 1 ? "道题" : "道题"}`;
    }
    if (props.language === "spanish") {
      return `${count} ${count === 1 ? "pregunta" : "preguntas"}`;
    }
    return `${count} ${count === 1 ? "question" : "questions"}`;
  };

  const attemptsLabel = (count, limit) => {
    if (props.language === "chinese") {
      return `${count} / ${limit === null || limit === 0 ? "∞" : limit} 次尝试`;
    }
    if (props.language === "spanish") {
      return limit === null || limit === 0
        ? `${count} / ∞ Intentos`
        : `${count} / ${limit} intentos`;
    }
    return limit === null || limit === 0
      ? `${count} / ∞ Attempts`
      : `${count} / ${limit} attempts`;
  };

  // const [hasDataLoaded, setHasDataLoaded] = React.useState(false)

  // React.useEffect(() => {
  //   if (props.block.id) {
  //     setHasDataLoaded(true)
  //   }
  // }, [props.block.id])


  const { block, editor } = props;
  // BlockNote drops object props (quizSelected) on drag/copy-paste but keeps
  // primitive ones, so we mirror the selection into quizUuid/quizName. If the
  // object was wiped, rebuild it from the surviving uuid — using the full quiz
  // from quizzesData when available (keeps the question count / pass %), else a
  // minimal {uuid, name}. The backend re-hydrates the full object on next read.
  const { quizSelected: rawQuizSelected, quizUuid, quizName } = block.props;
  // BlockNote can wipe the object prop to an empty {} on drag (not just null),
  // so only trust rawQuizSelected when it actually carries a uuid; otherwise
  // rebuild from the drag-proof primitives — the full quiz from quizzesData
  // when available (keeps question count / pass %), else a minimal {uuid, name}.
  const effectiveQuizUuid = rawQuizSelected?.uuid || quizUuid || null;
  const quizSelected = !effectiveQuizUuid
    ? null
    : rawQuizSelected?.uuid
      ? rawQuizSelected
      : props.quizzesData?.find((q) => q?.uuid === effectiveQuizUuid) || {
          uuid: effectiveQuizUuid,
          name: quizName,
        };

  const [openSelectQuizModal, setOpenSelectQuizModal] = React.useState(false);
  const handleOpenSelectQuizModal = () => setOpenSelectQuizModal(true);
  const handleCloseSelectQuizModal = () => setOpenSelectQuizModal(false);

  const [openCompleteQuizModal, setOpenCompleteQuizModal] = React.useState(false);
  const handleOpenCompleteQuizModal = () => setOpenCompleteQuizModal(true);
  const handleCloseCompleteQuizModal = () => setOpenCompleteQuizModal(false);

  const handleQuizSelect = (selectedQuiz) => {
    editor.updateBlock(block, {
      ...block,
      props: {
        ...block.props,
        quizSelected: selectedQuiz,
        // Drag-proof primitive mirror (see the block.props read above).
        quizUuid: selectedQuiz?.uuid || "",
        quizName: selectedQuiz?.name || "",
      },
    });
  };

  const [isChecked, setIsChecked] = React.useState(quizSelected?.user_has_passed);

  // A test-out quiz with no attempts left: nothing is wrong, the employee just
  // takes the sections it would have skipped.
  const testOutAttemptsUsed =
    quizSelected?.gate_on_pass === false &&
    !quizSelected?.user_has_passed &&
    quizSelected?.retake_limit > 0 &&
    (quizSelected?.pass_attempt_count || 0) >= quizSelected?.retake_limit;
  // A manager taking their own training is the learner here, and can't exempt themselves.
  const isLearnerOnTestOut =
    testOutAttemptsUsed && (props.userType === "Employee" || !props.employeeID);


  // React.useEffect(() => {
  //   if (hasDataLoaded && props.quizzesData && block.id && editor) {
  //     const newQuizSelected = props.quizzesData?.find(quiz => quiz?.uuid === quizSelected?.uuid);
  //     if (newQuizSelected && hasDataLoaded) {
  //       handleQuizSelect(newQuizSelected)
  //     }
  //   }
  // }, [props.quizzesData, hasDataLoaded]);

  return (
    <>
      {!quizSelected ?
        <div
          className="my-3 w-full p-4 border-2 border-dashed border-violet-300 rounded-xl text-sm text-violet-700 hover:bg-violet-50 hover:border-violet-500 transition-colors flex items-center justify-center gap-2 cursor-pointer focus:outline-none relative"
          onClick={handleOpenSelectQuizModal}
          contentEditable={false}
        >
          <QuizOutlinedIcon style={{ fontSize: 18 }} />
          <span>{t("Add quiz", "Agregar cuestionario", "添加测验")}</span>
          {/* BlockNote requires a DOM target for inline-content blocks
              even when (as here) the placeholder has no editable text.
              Park it off-flow so its min-height + width don't push the
              centered icon+label layout. Same trick is used on Signature
              for the same reason. */}
          <span
            ref={props.contentRef}
            style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
          />
        </div> :
        ((quizSelected.quiz_needs_manager_check === true || testOutAttemptsUsed) && props.type !== "Preview") ?
          <div
            className={"white rounded-lg relative px-6 py-3 w-full border border-slate-200 flex items-center justify-between"}
            // ref={props.contentRef}
            contentEditable={false}
          >
            <div className="flex-1">
              <div className="flex items-center gap-2 flex-wrap mb-2">
                <h2 className="text-2xl text-slate-900 font-semibold">{quizSelected?.name}</h2>
                <span className={`px-2 py-0.5 text-xs font-medium rounded ${testOutAttemptsUsed ? "bg-slate-100 text-slate-700" : "bg-rose-100 text-rose-700"}`}>
                  {testOutAttemptsUsed
                    ? t("Not passed", "No aprobado", "未通过")
                    : t("Failed", "Reprobado", "未通过")}
                </span>
              </div>
              <p
                className={`${testOutAttemptsUsed ? "text-slate-600" : "text-rose-800"} w-3/4`}
                style={{ marginTop: 2, fontSize: 12 }}
              >
                {isLearnerOnTestOut
                  ? t(
                      "You can continue. The next sections are required for you.",
                      "Puedes continuar. Las siguientes secciones son obligatorias para ti.",
                      "你可以继续。接下来的章节是你必须完成的。"
                    )
                  : testOutAttemptsUsed
                  ? t(
                      "Did not pass. Check the box to let this employee skip the sections this quiz covers.",
                      "No aprobó. Marca la casilla para que este empleado omita las secciones que cubre este cuestionario.",
                      "未通过。勾选此框可让该员工跳过此测验涵盖的章节。"
                    )
                  : t(
                      "You have exhausted all your attempts and did not meet the passing percentage. To proceed, have your manager check off the box.",
                      "Has agotado todos tus intentos y no alcanzaste el porcentaje de aprobación. Para continuar, pide a tu gerente que marque la casilla.",
                      "你已用完所有尝试次数，且未达到通过分数。若要继续，请让你的经理勾选此框。"
                    )}
              </p>
              <div>
                <div className="flex items-center gap-x-2 mt-1.5">
                  <div>
                    <ChecklistIcon style={{ fontSize: 18 }} />
                  </div>
                  <p
                    className="text-slate-900 text-sm"
                    style={{ fontSize: 14 }}
                  >
                    {questionCountLabel(quizSelected?.learning_questions_count)}
                  </p>
                </div>
                {quizSelected.pass_percentage > 0 &&
                  <div className="flex items-center gap-x-2 mt-1.5">
                    <div>
                      <FlagOutlinedIcon style={{ fontSize: 18 }} />
                    </div>
                    <p
                      className="text-slate-900 text-sm"
                      style={{ fontSize: 14 }}
                    >
                      {quizSelected?.pass_percentage}% {t("pass percentage", "porcentaje de aprobación", "通过分数")}
                    </p>
                  </div>
                }
                <div className="flex items-center gap-x-2 mt-1.5">
                  <div>
                    <LockOutlinedIcon style={{ fontSize: 18 }} />
                  </div>
                  <p
                    className="text-slate-900 text-sm"
                    style={{ fontSize: 14 }}
                  >
                    {attemptsLabel(
                      quizSelected?.pass_attempt_count ? quizSelected?.pass_attempt_count : 0,
                      quizSelected?.retake_limit
                    )}
                  </p>
                </div>
              </div>
            </div>
            {isLearnerOnTestOut ? null : !isChecked ?
              <div
                className={`w-10 h-10 border border-slate-200 rounded bg-white ${props.userType !== "Employee" ? "hover:bg-slate-50 cursor-pointer" : ""}`}
                onClick={async () => {
                  if (props.userType === "Employee") return;
                  if (testOutAttemptsUsed) {
                    // The server can refuse this (a manager on their own row), so
                    // only show the check once it's saved.
                    const result = await props.post_learning_block_user_passed(
                      quizSelected.uuid, true, props.employeeID, null, null, { silent: true }
                    );
                    if (result?.error_message) {
                      toast.error(result.error_message);
                      return;
                    }
                  } else {
                    props.post_learning_block_user_passed(quizSelected.uuid, true, props.employeeID);
                  }
                  setIsChecked(true);
                }}
              ></div> :
              <div
                className="w-10 h-10 border border-white rounded flex items-center justify-center bg-emerald-600 text-white"
              >
                <CheckIcon style={{ fontSize: "26px" }} />
              </div>
            }
          </div> :
          (() => {
            // Compose the metadata subtitle: "5 questions · 70% to pass · 0 / 3 attempts".
            // Same data the previous icon-list rendered, just inlined as a single line
            // to match the SwipeDeck hero treatment below.
            const subtitleParts = [];
            if (quizSelected?.learning_questions_count != null) {
              subtitleParts.push(questionCountLabel(quizSelected.learning_questions_count));
            }
            if (quizSelected?.pass_percentage > 0) {
              subtitleParts.push(
                `${quizSelected.pass_percentage}% ${t("to pass", "para aprobar", "通过")}`,
              );
            }
            // Only when the retake limit is known — a just-dragged quiz that
            // hasn't been re-hydrated yet has no limit, and "0 / undefined
            // attempts" reads as broken.
            if (quizSelected?.retake_limit !== undefined) {
              // pass_attempt_count is the viewer's own used attempts (per
              // user). In the section editor / track preview (type === "Preview")
              // that's the admin's count, which is irrelevant to authoring — show
              // 0 used there so it reads as the retake-limit config. The real
              // used count only matters in the live/learner view.
              const usedAttempts =
                props.type !== "Preview"
                  ? quizSelected?.pass_attempt_count || 0
                  : 0;
              subtitleParts.push(
                attemptsLabel(usedAttempts, quizSelected?.retake_limit),
              );
            }
            const subtitleText = subtitleParts.join(" · ");

            return (
              <button
                type="button"
                onClick={handleOpenCompleteQuizModal}
                contentEditable={false}
                className="my-3 group relative w-full overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5"
                style={{
                  // Emerald gradient — distinguishes the quiz hero from the
                  // violet swipe-deck hero while keeping the same visual
                  // language (135deg / 3-stop gradient / decorative rings).
                  background:
                    "linear-gradient(135deg, #059669 0%, #047857 60%, #064e3b 100%)",
                  minHeight: 132,
                }}
              >
                {/* Decorative radial accents — same Stories-style cue as SwipeDeck */}
                <div
                  aria-hidden="true"
                  className="absolute -top-12 -right-12 w-36 h-36 rounded-full opacity-25"
                  style={{
                    background:
                      "radial-gradient(circle, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 70%)",
                  }}
                />
                <div
                  aria-hidden="true"
                  className="absolute -bottom-16 -left-12 w-40 h-40 rounded-full opacity-15"
                  style={{
                    background:
                      "radial-gradient(circle, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 70%)",
                  }}
                />

                {props.onEditAsset && effectiveQuizUuid && (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onEditAsset(effectiveQuizUuid);
                    }}
                    className="absolute top-3 right-3 z-10 flex items-center gap-1 px-2.5 py-1 rounded-lg bg-white/20 backdrop-blur-sm text-white text-xs font-medium hover:bg-white/30 transition-colors cursor-pointer"
                  >
                    <EditOutlinedIcon style={{ fontSize: 14 }} />
                    {t("Edit", "Editar", "编辑")}
                  </div>
                )}

                <div className="relative flex items-center gap-4 px-6 py-5 text-white text-left">
                  {/* Affordance — ChecklistIcon signals "quiz" semantically,
                      where SwipeDeck uses PlayArrowIcon to signal "play". */}
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white/30 transition-colors">
                    <ChecklistIcon style={{ fontSize: 26 }} />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 flex-wrap">
                      <div className="text-lg font-semibold leading-tight truncate">
                        {quizSelected?.name}
                      </div>
                      {/* Pass state is per learner; the backend re-hydrates the
                          viewing admin's own user_has_passed, so only show it in
                          the live/learner view (type !== "Preview") — not in the
                          section editor or track/module preview. */}
                      {props.type !== "Preview" && quizSelected.user_has_passed && (
                        <span className="px-2 py-0.5 bg-white/95 text-emerald-700 text-xs font-medium rounded">
                          {t("Passed", "Aprobado", "已通过")}
                        </span>
                      )}
                    </div>
                    <div className="text-sm opacity-85 mt-0.5">
                      {subtitleText}
                    </div>
                  </div>
                </div>
              </button>
            );
          })()
      }
      <AddQuizToSectionModal
        open={openSelectQuizModal}
        handleClose={handleCloseSelectQuizModal}
        quizSelected={quizSelected}
        handleQuizSelect={handleQuizSelect}
        quizzesData={props.quizzesData}
        homeCompany={props.homeCompany}
      />
      <CompleteQuizModal
        open={openCompleteQuizModal}
        handleClose={handleCloseCompleteQuizModal}
        quizSelected={quizSelected}
        homeCompany={props.homeCompany}
        post_learning_block_user_passed={props.post_learning_block_user_passed}
        employeeID={props.employeeID}
        type={props.type}
        setRefreshSection={props.setRefreshSection}
        language={props.language}
      />
    </>
  );
};
